// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"879":"3cec0a9b","6506":"5c58c630","7583":"5c58c630","7892":"c3c0b704","9246":"92da811b","9676":"c3c0b704","9958":"c3c0b704"}[chunkId] + ".chunk.css";
};